import React, { useEffect, useState } from 'react';
import ColorModel from './models/ColorModel';

function ViewColor({ ColorData }) {
  const [colorDetails, setColorDetails] = useState(new ColorModel());

  useEffect(() => {
    setColorDetails(ColorData);
  }, [ColorData]);

  return (
    <div className="row">
      <div className="mb-3 add-product">
        <label className="form-label">Color Name</label>
        <input type="text" className="form-control" value={colorDetails.ColorName || ''} disabled />
      </div>
      <div className="mb-3 add-product">
        <label className="form-label">Color Code</label>
        <input type="text" className="form-control" value={colorDetails.ColorCode || ''} disabled />
      </div>
      <div className="mb-3 add-product">
        <label className="form-label">Description</label>
        <textarea className="form-control h-100" rows="5" value={colorDetails.Description || ''} disabled />
      </div>
    </div>
  );
}

export default ViewColor;
